module.exports = __webpack_public_path__ + "static/webinar18_infographic-00aed513784bfe409f9ad5724e773216.pdf";